// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3fBHJ","icon":"SortAdornment_icon__1c6rA","up":"SortAdornment_up__2wM4p","down":"SortAdornment_down__Qjskv","active":"SortAdornment_active__2C4tw"};